import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import JsonViewer from "vue-json-viewer"
import cache from "./plugins/cache.js"
import VueGtag from "vue-gtag";


Vue.config.productionTip = false

Vue.use(JsonViewer)
Vue.use(VueGtag, {
  config: { id: "G-GE5Z4P9E3Z" },
  appName: 'Decision Aid - Bladder Cancer',
  pageTrackerScreenviewEnabled: true
},router);

let code = new Vue({
  created: function(){
    Vue.prototype.cache = cache
  },
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

if(location.hostname=="localhost"){
  window.code = code;
}